import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import { updateQuiz } from '../actions/index';
import { HELPERS } from '../config/constants';

import QuestionNavItem from './QuestionNavItem';
import '../styles/QuestionNav.css';

import arrowLeft from '../images/arrow-left.svg';
import arrowRight from '../images/arrow-right.svg';

class QuestionNav extends Component {
  constructor(props) {
    super(props);

    this.navItemRange =
      (Math.floor((window.innerWidth - 80) / 45) >= 20
        ? Math.min(this.props.questions.length, 20)
        : Math.min(
            this.props.questions.length,
            Math.floor((window.innerWidth - 75) / 52)
          )) - 1;

    this.state = {
      navItemRange: this.navItemRange,
      currentRange: [0, this.navItemRange]
    };

    this.onKeyDown = _.debounce(this.onKeyDown, 75, {
      leading: true,
      trailing: false
    }).bind(this);

    this.canNavBack = this.canNavBack.bind(this);
    this.canNavForward = this.canNavForward.bind(this);
    this.handleNavBack = this.handleNavBack.bind(this);
    this.handleNavForward = this.handleNavForward.bind(this);
    this.nextQuestion = this.nextQuestion.bind(this);
    this.prevQuestion = this.prevQuestion.bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  onKeyDown(e) {
    switch (e.key) {
      case 'ArrowRight':
        e.shiftKey
          ? e.altKey
            ? this.canNavForward() ? this.handleNavForward() : null
            : this.nextQuestion()
          : null;
        break;
      case 'ArrowLeft':
        e.shiftKey
          ? e.altKey
            ? this.canNavBack() ? this.handleNavBack() : null
            : this.prevQuestion()
          : null;
        break;
      default:
    }
  }

  canNavBack() {
    return this.state.currentRange[0] >= this.navItemRange;
  }

  canNavForward() {
    return this.state.currentRange[1] < this.props.questions.length - 1;
  }

  handleNavBack() {
    this.state.currentRange[0] >= this.navItemRange
      ? this.setState({
          currentRange: this.state.currentRange.map(n => n - this.navItemRange)
        })
      : null;
  }

  handleNavForward() {
    this.state.currentRange[1] < this.props.questions.length - 1
      ? this.setState({
          currentRange: this.state.currentRange.map(n => n + this.navItemRange)
        })
      : null;
  }

  nextQuestion() {
    const { currentQuestionIndex, questions, updateQuiz } = this.props;
    currentQuestionIndex < questions.length - 1
      ? updateQuiz(
          HELPERS.UPDATE_OBJECT({
            currentQuestionIndex: currentQuestionIndex + 1
          })
        )
      : null;
  }

  prevQuestion() {
    const { currentQuestionIndex, updateQuiz } = this.props;
    currentQuestionIndex > 0
      ? updateQuiz(
          HELPERS.UPDATE_OBJECT({
            currentQuestionIndex: currentQuestionIndex - 1
          })
        )
      : null;
  }

  componentWillReceiveProps(props) {
    const newRange =
      this.props.questions.length !== props.questions.length
        ? {
            navItemRange:
              Math.floor((window.innerWidth - 75) / 52) >= 20
                ? Math.min(props.questions.length, 20)
                : Math.min(
                    props.questions.length,
                    Math.floor((window.innerWidth - 75) / 52)
                  )
          }
        : {};

    if (this.props.questions.length !== props.questions.length) {
      this.setState({ currentRange: [0, newRange.navItemRange] });
    } else if (props.selectedIndex < this.state.currentRange[0]) {
      this.setState(
        Object.assign(
          {
            currentRange: [
              props.selectedIndex,
              props.selectedIndex + this.navItemRange
            ]
          },
          newRange
        )
      );
    } else if (props.selectedIndex > this.state.currentRange[1]) {
      this.setState(
        Object.assign(
          {
            currentRange: [
              props.selectedIndex - this.navItemRange,
              props.selectedIndex
            ]
          },
          newRange
        )
      );
    }
  }

  render() {
    return (
      <div className="question-nav">
        <p className={`nav-nav${this.canNavBack() ? '' : ' hide-nav-nav'}`}>
          <span onClick={this.handleNavBack}>
            <img alt="" src={arrowLeft} />
          </span>
        </p>
        {this.props.questions.map((q, index) => (
          <QuestionNavItem
            key={index}
            index={index}
            visible={
              index >= this.state.currentRange[0] &&
              index <= this.state.currentRange[1]
            }
            scoreCardDisplay={
              this.props.selectedIndex < this.state.currentRange[0]
                ? this.state.currentRange[0] === index
                : this.props.selectedIndex > this.state.currentRange[1]
                  ? this.state.currentRange[1] === index
                  : this.props.selectedIndex === index
            }
          />
        ))}
        <p className={`nav-nav${this.canNavForward() ? '' : ' hide-nav-nav'}`}>
          <span onClick={this.handleNavForward}>
            <img alt="" src={arrowRight} />
          </span>
        </p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { currentQuestionIndex, questions } = state.quiz;

  return {
    questions,
    selectedIndex: state.quiz.currentQuestionIndex,
    currentQuestionIndex
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateQuiz }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionNav);



// WEBPACK FOOTER //
// ./src/containers/QuestionNav.js